import { render, staticRenderFns } from "./ordersettingflow.vue?vue&type=template&id=3b9a7034&"
import script from "./ordersettingflow.vue?vue&type=script&lang=js&"
export * from "./ordersettingflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports